import * as yup from "yup"

export const schemaValidation = yup.object().shape({
  redButtonStatus: yup.boolean(),
})